import React from 'react';
import { DriverGreeting } from '../driverDashboardTypes';
import styles from './DriverGreetingHeader.module.css';

interface DriverGreetingHeaderProps {
  data: DriverGreeting;
}

export const DriverGreetingHeader: React.FC<DriverGreetingHeaderProps> = ({ data }) => {
  return (
    <div className={styles.card}>
      <div className={styles.topRow}>
        <div>
          <p className={styles.greeting}>{data.greeting}</p>
          <h2 className={styles.name}>{data.driverName}</h2>
          <p className={styles.subtitle}>{data.subtitle}</p>
        </div>
        <span className={`${styles.statusBadge} ${styles[data.status.toLowerCase()]}`}>
          <span className={styles.dot} />
          {data.status}
        </span>
      </div>
      <div className={styles.metaRow}>
        <div className={styles.metaItem}>
          <span className={styles.metaLabel}>Vehicle Assigned</span>
          <span className={styles.metaValue}>{data.vehicleAssigned}</span>
        </div>
        <div className={styles.metaItem}>
          <span className={styles.metaLabel}>Shift Date</span>
          <span className={styles.metaValue}>{data.shiftDate}</span>
        </div>
        <div className={styles.metaItem}>
          <span className={styles.metaLabel}>Territory</span>
          <span className={styles.metaValue}>{data.territory}</span>
        </div>
      </div>
    </div>
  );
};
